import {AdDetailsAggregate} from '../Aggregates/AdDetailsAggregate.js'

export class AdsAggregatesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {AdEntity<Entity>} deps.ad
   * @param {AdType<ValueObject>} deps.adType
   * @param {Boolean} deps.isTradable
   * @param {SellerValueObject<ValueObject>} deps.seller
   * @param {AdListValueObjectLegacy<ValueObject>} deps.recommendedAds
   * @param {VehicleHistoryValueObject<ValueObject>} deps.vehicleHistory
   * @param {VehicleInfoValueObject<ValueObject>} deps.vehicleInfo
   * @param {String} deps.status
   * @return {AdDetailsAggregate}
   */
  static adDetailsAggregate = ({
    ad,
    adStats,
    adType,
    financingData,
    isTradable,
    recommendedAds,
    isRecommendedAdsFallback,
    reservation,
    seller,
    status,
    vehicleCertification,
    vehicleData,
    vehicleHistory,
    vehicleInfo
  }) =>
    new AdDetailsAggregate({
      ad,
      adStats,
      adType,
      financingData,
      isTradable,
      recommendedAds,
      isRecommendedAdsFallback,
      reservation,
      seller,
      status,
      vehicleCertification,
      vehicleData,
      vehicleHistory,
      vehicleInfo
    })
}
